module.exports = __webpack_public_path__ + "img/why.7c8d339f.png";